import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { UserWithSecrets } from "@reactive-resume/dto";
import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export const changeStatusAccount = async (id?: string) => {
  const response = await axios.patch<UserWithSecrets, AxiosResponse<UserWithSecrets>>(`user/${id}`);

  return response.data;
};

export const useChangeActivation = () => {
  const { mutateAsync: changeStatusAccountFn } = useMutation({
    mutationFn: (id: string) => changeStatusAccount(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["filter-user"] });
      queryClient.invalidateQueries({ queryKey: ["filter-ambassador"] });
      queryClient.invalidateQueries({ queryKey: ["filter-admin"] });
    },
  });
  return { ChStatus: changeStatusAccountFn };
};
